import React from 'react';
import { Button } from './ui/button';
import { MessageCircle, Calendar, Star } from 'lucide-react';
import { businessInfo } from '../data/mock';
import { trackBooking, trackWhatsApp } from '../lib/analytics';

const Hero = () => {
  const handleWhatsApp = () => {
    trackWhatsApp('hero');
    const message = 'Olá! Vim pelo site da ABR Barbearia e gostaria de agendar um horário.';
    const url = `https://wa.me/${businessInfo.phone}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  const handleBooking = () => {
    trackBooking('hero');
    window.open(businessInfo.bookingUrl, '_blank');
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden" data-testid="hero-section">
      {/* Hero-specific background with the fachada image properly framed */}
      <div
        className="absolute inset-0 bg-no-repeat bg-center"
        style={{
          backgroundImage:
            "url('https://customer-assets.emergentagent.com/job_barbeiros-jundiai/artifacts/nzj2j8g2_IMG_0137.jpeg')",
          backgroundSize: 'cover',
          backgroundPosition: 'center 35%',
        }}
      ></div>
      {/* Dark gradient overlay for premium readability */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/40 to-black/80 pointer-events-none"></div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 text-center">
        <div className="max-w-4xl mx-auto space-y-6 animate-fade-in">
          {/* Google rating badge */}
          <div className="inline-flex items-center gap-3 px-5 py-2 rounded-full bg-black/60 backdrop-blur-md border border-[#D4AF37]/40" data-testid="google-rating-badge">
            <div className="flex gap-0.5">
              {[...Array(5)].map((_, i) => (
                <Star key={`hero-star-${i}`} className="h-4 w-4 fill-[#D4AF37] text-[#D4AF37]" />
              ))}
            </div>
            <span className="text-white text-sm font-medium">
              <span className="text-[#D4AF37] font-bold">5,0</span> Avaliação no Google
            </span>
          </div>

          <h1 className="text-5xl md:text-7xl font-bold text-white leading-tight">
            Mais que um corte.
            <br />
            <span className="text-[#D4AF37]">Uma experiência.</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 max-w-2xl mx-auto">
            Barbearia premium em Jundiaí com atendimento de alto padrão.
          </p>
          <div className="pt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button
              onClick={handleBooking}
              data-testid="hero-booking-btn"
              size="lg"
              className="bg-[#D4AF37] hover:bg-[#B8941F] text-black font-semibold text-lg px-8 py-6 rounded-sm transition-all duration-300 hover:scale-105"
            >
              <Calendar className="mr-2 h-5 w-5" />
              Agendar Agora
            </Button>
            <Button
              onClick={handleWhatsApp}
              data-testid="hero-whatsapp-btn"
              variant="outline"
              size="lg"
              className="border-white text-white bg-white/10 hover:bg-white hover:text-black font-semibold text-lg px-8 py-6 rounded-sm transition-all duration-300 hover:scale-105 backdrop-blur-sm"
            >
              <MessageCircle className="mr-2 h-5 w-5" />
              Falar no WhatsApp
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-[#D4AF37] rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-[#D4AF37] rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
